import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';

class RangeInput extends React.Component {
    static propTypes = {
        value: PropTypes.object,
        prefix: PropTypes.string,
        onChange: PropTypes.func
    };

    static defaultProps = {
        value: {
            start: '',
            end: ''
        }
    };

    constructor(props, context) {
        super(props, context);

        this.state = this.getState(props);
    }

    getState(props) {
        return {
            value: props.value
        };
    }

    changeStart(e) {
        const start = e.target.value;

        if (e.target.value && isNaN(parseFloat(start))) {
            return;
        }

        const value = {
            ...this.state.value,
            start
        };

        this.setState({
            value
        });

        this.onChange(value);
    }

    changeEnd(e) {
        const end = e.target.value;

        if (e.target.value && isNaN(parseFloat(end))) {
            return;
        }

        const value = {
            ...this.state.value,
            end
        };

        this.setState({
            value
        });

        this.onChange(value);
    }

    onChange(value) {
        if (this.props.onChange) {
            this.props.onChange(value || this.state.value);
        }
    }

    onCheckMaxValue() {
        let { start, end } = this.state.value;

        const startParsed = parseFloat(start) || '';
        const endParsed = parseFloat(end) || '';

        if (startParsed && endParsed && startParsed > endParsed) {
            start = end;
        }

        this.setState({
            value: {
                start,
                end
            }
        });
    }

    render() {
        const { prefix } = this.props;
        const { start, end } = this.state.value;

        const startInput = (
            <input
                type='text'
                label={ 'From' }
                value={ start }
                onChange={ this.changeStart.bind(this)}
                onBlur={ this.onCheckMaxValue.bind(this)}
                data-test='from'
            />
        );

        const endInput = (
            <input
                type='text'
                label={ 'To' }
                value={ end }
                onChange={ this.changeEnd.bind(this)}
                onBlur={ this.onCheckMaxValue.bind(this)}
                data-test='to'
            />
        );

        if (prefix) {
            return (
                <div className='row range-input range-input__prefixed'>
                    <div className='col-1'>
                        <span className='range-input-prefix'>{ prefix }</span>
                    </div>
                    <div className='col-5'>
                        { startInput }
                    </div>
                    <div className='col-1'>
                        <span className='range-input-prefix'>{ prefix }</span>
                    </div>
                    <div className='col-5'>
                        { endInput }
                    </div>
                </div>
            );
        }

        return (
            <div className='row range-input'>
                <div className='col-6'>
                    { startInput }
                </div>
                <div className='col-6'>
                    { endInput }
                </div>
            </div>
        );
    }
}

export default RangeInput;
